<div class="table ">
    <table>
        <thead>
            <tr>
                <th>{{'Rating'|translate}}</th>
                <th>{{'Diagnostic Procedures'|translate}}</th>
                <th>{{'State'|translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr mdbTableCol *ngFor="let i of candidateData">
                <th *ngIf="i.rating=='5'">
                    <span *ngFor="let q of [5,5,5,5,5] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='4'">
                    <span *ngFor="let q of [4,4,4,4] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='3'">
                    <span *ngFor="let q of [3,3,3] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='2'">
                    <span *ngFor="let q of [5,5] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='1'">
                    <span>
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <td>{{i.procedure}}</td>
                <td>{{i.state}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="box1-left"></div>
<div class="box1"></div>
<div class="box1"></div>
<div class="box1"></div>
<div class="box1"></div>

<div style="padding-top:0%">
    <i style="color:grey; margin-left: 6%;">= {{'Confidence rating'|translate}}</i>
</div>
<div>
    <button class="buttons">{{'RETRY'|translate}}</button>
    <button class="buttons" *ngIf="btnName == 'REPAIR CANDIDATES'" routerLink="/repairProcedures">{{'btnName'|translate}}</button>
    <button class="buttons" *ngIf="btnName == 'POST REPAIR CANDIDATES'" routerLink="/postrepairProcedures">{{'btnName'|translate}}</button>
</div>
<div id="swUpgrade"></div>